/**
 * SEO helpers: canonical OG image dimensions and JSON-LD generation.
 */

const CDN_PREFIX = "https://cdn.manupgame.com/";

export const OG_WIDTH = 1200;
export const OG_HEIGHT = 630;

/**
 * Wraps a CDN-hosted image in a Cloudflare image transformation that
 * crops/scales to the OG-recommended 1200x630 and forces JPEG (some
 * social validators reject WebP/AVIF for og:image).
 *
 * Pass-through for anything not hosted on cdn.manupgame.com.
 */
export const ogImage = (url: string): string => {
  if (!url.startsWith(CDN_PREFIX)) return url;
  const path = url.slice(CDN_PREFIX.length);
  return `${CDN_PREFIX}cdn-cgi/image/width=${OG_WIDTH},height=${OG_HEIGHT},fit=cover,quality=85,format=jpeg/${path}`;
};

/**
 * Build the meta tag tuple for an og:image with explicit dimensions.
 * Twitter and Facebook validators warn without width/height.
 */
export const ogImageMeta = (url: string) => [
  { property: "og:image", content: ogImage(url) },
  { property: "og:image:width", content: String(OG_WIDTH) },
  { property: "og:image:height", content: String(OG_HEIGHT) },
  { property: "og:image:type", content: "image/jpeg" },
  { name: "twitter:image", content: ogImage(url) },
];

/**
 * Render a JSON-LD `<script type="application/ld+json">` via Remix's
 * `meta` function. Remix recognizes `script:ld+json` and emits a
 * properly typed script tag.
 */
export const jsonLd = (data: Record<string, unknown>) => ({
  "script:ld+json": data,
});
